<template lang="html" xmlns:svg="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <div class="gallery">
    <div class="info_scenario hidden">
      <div class="info_scenario_wrap">
        <div class="info_scenario_titles">

          <div v-for="(title, indexTitle) in useCaseTitle" class="title">
            <span class="title_text">{{title}}</span>
          </div>
        </div>
        <div class="info_scenario_controls">
          <router-link :to="'/'+ language +'/configurator/' + currentScenario.url"><div class="buttons" type="button" name="button"><span>Start</span></div></router-link>
        </div>
      </div>
    </div>
  <div class="grid" id="svgWrapper">
    <div :data-id="index"  :data-ratio="image.coverRatio"  v-for="(image,index) in scenarios" class="grid-item" >
      <div class="wrapper">
        <h2 class="title-scenario" v-if="language == 'en'"> {{image.name}} </h2>
        <h2 class="title-scenario" v-else> {{image.name_de}} </h2>
        <img  class="grid-item-cover" width="100%" :src="image.path" :data-src="image.path_full"/>
      </div>
    </div>
  </div>
</div>
</template>
<script>

/* eslint-disable */
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";

import scenarios from '../assets/furnituresScenarios.json';
import { masterBus } from '@/main.js';
import { mapGetters } from 'vuex'

export default {
  data(){
    return{
      windowWidth:null,
      windowHeight:null,
      svgWrapper:null,
      margin:60,
      isUseCaseOpened:false,
      widthImages:0,
      galleryTl:null,
      windowRatio:0,
      useCaseTitle:[],
      galleryViewbox:[0,0,0,0],
      scenarios:scenarios,
      curTop:0,
      animationRunning:true,
      currentScenario:{},
      resizeTimeout:null,
      galleryInitiated:false
    }
  },
  computed: {
    ...mapGetters(['appReady','language','infoOpened'])
  },
  beforeRouteLeave(to,from,next){
    this.startScenario(next);
  },
  beforeDestroy(){
    masterBus.$off('resetGallery',this.hideInfos);
  },
  watch:{
    language:function(val){
        this.switchScenarioTitle(val);
    }
  },
  mounted(){
    TweenMax.set('.app-content',{'background':'white'});
    TweenMax.set('.configurator_app',{height:'100vh'});
    masterBus.$on('resetGallery',this.hideInfos);
    $('.logo_svg').addClass("light");
    $('.header .back').addClass("hidden");
    this.initGallery();
    $('#svgWrapper').imagesLoaded( {
        // options...
      }).done(()=>{
        this.displayGallery();
        this.loadBiggerImages();
      }).progress( function( instance, image ) {
        // var result = image.isLoaded ? 'loaded' : 'broken';
        // console.log( 'image is ' + result + ' for ' + image.img.src );
     });
     window.addEventListener('resize', ()=>{
       clearTimeout(this.resizeTimeout);
       this.resizeTimeout = setTimeout(this.initGallery, 100);
     });
  },
  methods:{
    loadBiggerImages(){
      $(".grid-item-cover").each(function(index,elem){
        let fullSizeSrc = $(this).attr("data-src");
        if(fullSizeSrc){
          var newImg = new Image();
          newImg.src = fullSizeSrc;
          newImg.onload = ()=>{
            $(this).attr("src",newImg.src);
          }
        }
      })
    },
    initGallery(){
      let isResize = this.galleryInitiated;
      var columns= 3;
      this.windowWidth = $(window).width();
      this.windowHeight = $(window).height();
      if(this.windowWidth <= 1024) this.margin = 30;
      else this.margin = 60;
      if(this.windowWidth < 560) columns= 1;
      else if(this.windowWidth < 1000) columns=2;
      this.windowRatio = this.windowHeight/this.windowWidth;
      $('#svgWrapper').css({'width':this.windowWidth});
      this.svgWrapper = document.getElementById("svgWrapper");
      this.widthImages= ((this.windowWidth - (this.margin*2 + this.margin*(columns-1) ))/columns);
      var indexColumn=0;
      var indexRow=0;
      var columnsHeight=[this.margin,this.margin,this.margin];
      $(".grid-item").each((index,elem)=>{
        var ratio = $(elem).attr("data-ratio");
        if (ratio == "landscape"){
          $(elem).css({"width":this.widthImages,'height':(this.widthImages*282/375)});
        }
        else {
          $(elem).css({"width":this.widthImages,'height':(this.widthImages*504/375)});
        }
        if(indexColumn == columns) {
          indexColumn = 0;
          indexRow += 1;
        }
        if(index == 6 && this.windowWidth <= 1000){
            indexColumn = 1;
        }
        if(index == 6 && this.windowWidth <= 560){
            indexColumn = 0;
        }
        var positionY = columnsHeight[indexColumn];
        var positionX = indexColumn * ((this.windowWidth-(this.margin*2 + this.margin*(columns-1) ))/columns + this.margin);
        $(elem).css({"left":(positionX+this.margin)+"px", "top": parseInt(positionY)+"px"});
        columnsHeight[indexColumn] += (parseInt($(elem).height())+this.margin);
        indexColumn +=1;
        if(index == 8){
          if(isResize){
            $('#svgWrapper').css({'height': (columnsHeight[0]+90) + "px"});
            this.recenterGallery();
          }
          else{
            if(this.windowWidth <= 560)$('#svgWrapper').css({'height': (columnsHeight[0]+90) + "px"});
            else $('#svgWrapper').css({'height': (columnsHeight[1]+90) + "px"});
            window.scrollTo(0,this.margin);
          }
        }
      });
      $('.grid-item').on("click",(event)=>{
        if(!this.isUseCaseOpened){
          var indexElem = $(event.currentTarget).attr("data-id");
          var ratio = $(event.currentTarget).attr("data-ratio");
          var zoomYPosition;
          this.changeScenarios(indexElem);
          this.zoomGallery(event.currentTarget,indexElem,ratio);
          this.isUseCaseOpened = true;
        }
      })
      this.galleryInitiated = true;
    },
    recenterGallery(){
      if(this.isUseCaseOpened){
        this.zoomGallery($("[data-id*="+this.currentScenario.index+"]")[0],this.currentScenario.index,this.currentScenario.coverRatio,true);
      }
    },
    changeScenarios(indexElem){
      this.currentScenario = this.scenarios[indexElem];
      this.currentScenario.index = indexElem;
      if(this.language == 'en'){
        this.useCaseTitle = this.scenarios[indexElem].titles;
      }
      else{
        this.useCaseTitle = this.scenarios[indexElem].titles_de;
      }
    },
    zoomGallery(target,index,orientation,resize){
        if(this.infoOpened){
          this.$store.dispatch('setInfoOpened',false);
        }
        if(!this.animationRunning){
          // let x = $(target).offset().left + 3 ;
          // let y = $(target).offset().top;
          let x = parseInt($(target).css('left').slice(0,$(target).css('left').length-2))+3 ;
          let y = parseInt($(target).css('top').slice(0,$(target).css('top').length-2));
          this.windowWidth = $(window).width();
          this.windowHeight = $(window).height();
          var elemHeight = $(target).height();

          this.animationRunning = true;
          $('.title-scenario').addClass("hidden");
          $('.info_scenario').bind('touchmove click', function(e){e.preventDefault()})
          $(this.svgWrapper).bind('touchmove', function(e){e.preventDefault()})

          if(orientation == "portrait" && this.windowWidth>=1000) y = parseInt(y) + elemHeight/4;

          var galleryTl = new TimelineMax({onComplete:this.displayInfos});
          let zoomFactor;
          if(orientation == 'landscape'){
            let projectedHeight = this.windowWidth*282/375;
            if(projectedHeight < this.windowHeight){
              zoomFactor = ((this.windowHeight * 375 / 282)/this.widthImages) + 0.1;
              if(this.windowWidth >560 && !this.isUseCaseOpened)x = x+$("[data-id*="+index+"]").width()/7;
            }
            else{
              zoomFactor = (this.windowWidth / this.widthImages)+0.1;
            }
          }
          else{
            zoomFactor = (this.windowWidth / this.widthImages)+0.1;
          }
          if(resize){
            galleryTl.to(this.svgWrapper, .5, {ease: Power2.easeOut, x:-x, y:-y,'transformOrigin':x+'px ' + y + 'px',force3D:false,scale:zoomFactor}) //3.7
                     .to('.gallery',.5,{ease:Power2.easeOut,height: window.innerHeight},"-=.5")
                     .to(window, .2, {scrollTo:0});
          }
          else{
            galleryTl.to(this.svgWrapper, 1.5, {ease: Power2.easeOut, x:-x, y:-y,'transformOrigin':x+'px ' + y + 'px',force3D:false,scale:zoomFactor}) //3.7
                     .to('.gallery',1.5,{ease:Power2.easeOut,height: window.innerHeight},"-=1.5")
                     .to(window, .3, {scrollTo:0});
          }

        }
    },
    resetGallery(){
      TweenMax.set('.app-content',{'background':'white'});
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
      $('.grid-item').removeClass("blurred");
      $('.back').addClass("hidden");
      $('.back').removeClass("light");
      $('.controls-open-infos').removeClass("light");
      $('.info_scenario').unbind('click touchmove');
      $(this.svgWrapper).unbind('click touchmove');
      this.curTop = 0;
      $('.info_scenario').addClass("hidden");
      var galleryTl = new TimelineMax({onComplete:this.resetUseCase});
      let targetScroll = this.margin;
      if (this.windowWidth > 1000){
        galleryTl.to(this.svgWrapper, 1.5, {ease: Power2.easeOut,x:0,y:0,scale:1})
                 .to('.gallery',1.5,{ease:Power2.easeOut,height:"auto"},"-=1.5")
                 .to(window, .3, {scrollTo:this.margin},"-=1.5");
      }
      else{
        galleryTl.to(this.svgWrapper, 1.5, {ease: Power2.easeOut,x:0,y:0,scale:1})
                 .to('.gallery',1.5,{ease:Power2.easeOut,height:"auto"},"-=1.5");
      }
    },
    resetUseCase(){
      $('.title-scenario').removeClass("hidden");
      this.isUseCaseOpened = false;
    },
    startScenario(callback){
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
      this.hideInfos(this.hideGallery,callback);
    },
    hideGallery(callback){
      // var galleryTl = new TimelineMax();
      var galleryTl = new TimelineMax({onComplete:callback});
      galleryTl.to(".gallery", 1, {ease: Power2.easeOut,transform:"scale(1.2)",autoAlpha:0})
    },
    displayInfos(){
      this.animationRunning = false;
      $('.grid-item').addClass("blurred");
      $('.info_scenario').removeClass("hidden");
      if(this.currentScenario.url !== "debriefing-meeting"){
        $('.back').addClass("light");
        $('.controls-open-infos').addClass("light");
      }
      $('.back').removeClass("hidden");
      var infosTL =  new TimelineMax();
      infosTL.staggerTo(".title_text",.8,{ease:Power3.easeOut,bottom:0,alpha:1,stagger:.1},"-=0.5")
             .to(".info_scenario_controls",.3,{opacity:1},"-=.4");
    },
    hideInfos(callback,optionCallback){
      TweenMax.set('.app-content',{'background':'white'});
      if(callback == "fromHeader"){
        callback = this.resetGallery;
      }
      TweenMax.to('.app-content',.3,{'background':'rgb(244, 244, 244)'});
      TweenMax.to('.gallery',.3,{'background':'rgb(244, 244, 244)'});

      var infosTL =  new TimelineMax({onComplete:callback,onCompleteParams:[optionCallback]});
      infosTL.to(".info_scenario_controls",.6,{opacity:0})
              .staggerTo(".title_text",.6,{ease:Power3.easeOut,bottom:-160,alpha:1,stagger:-.1},"-=0.5")

    },
    displayGallery(){
      setTimeout(()=>{
        this.animationRunning = false;
      },400);
      var galleryTl = new TimelineMax();
      galleryTl.to(".gallery", 1, {ease: Power2.easeOut,transform:"scale(1)",autoAlpha:1})
    },
    switchScenarioTitle(lang){
      if(this.useCaseTitle){
        if(lang == 'en'){
          this.useCaseTitle = this.currentScenario.titles;
        }
        else{
        this.useCaseTitle = this.currentScenario.titles_de;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@media only screen and (max-width: 1200px)  {
  .info_scenario_titles{
    font-size: 7rem;
    .title{
      height: 126px;
    }
  }
}
@media only screen and (max-width: 920px)  {
  .info_scenario_titles{
    font-size: 5rem;
    .title{
      height: 90px;
    }
  }
}
@media only screen and (max-width: 660px)  {
  .info_scenario_titles{
    font-size: 3rem ;
    .title{
      height: 57px;
    }
  }
}
@media only screen and (min-width: 1200px)  {
  .info_scenario_titles{
    font-size: 9rem;
    .title{
      height: 166px;
    }
  }
}
.gallery{
  width: 100%;
  z-index: 2;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
  visibility: hidden;
  overflow: hidden;
  background: white;
  opacity:0;
  .info_scenario{
    position: absolute;
    top: 0;
    bottom: 0;
    left:0;
    right: 0;
    margin: auto;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    &.hidden{
      visibility: hidden;
    }
    .info_scenario_wrap{
      width: 100%;
    }
    .info_scenario_titles{
      margin-bottom: 40px;
      text-align: center;
      width: 100%;
      .title{
        min-width: 90%;
        position: relative;
        overflow: hidden;
        span{
          color: white;
          height: 100%;
          position: absolute;
          font-family:  'Union Regular',Helvetica, Arial, sans-serif;;
          font-weight:  normal;
          font-style:   normal;
          font-stretch: normal;
          bottom: -160px;
          left:0;
          right:0;
          margin: auto;
        }
      }
    }
    .info_scenario_controls{
      display: flex;
      justify-content: center;
      opacity:0;
      .buttons{
        padding: .8rem 2rem;
        background: white;
        border-radius: 40px;
        margin: 0 .6rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        height: 60px;
        border-radius: 30px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-transition: all .4s cubic-bezier(0, 0, 0.2, 1);
        -moz-transition: all .4s cubic-bezier(0, 0, 0.2, 1);
        -ms-transition: all .4s cubic-bezier(0, 0, 0.2, 1);
        -o-transition:all .4s cubic-bezier(0, 0, 0.2, 1);
        transition: all .4s cubic-bezier(0, 0, 0.2, 1);
        span{
          text-transform: uppercase;
          font-family:  'Union Regular',Helvetica, Arial, sans-serif;;
          font-weight:  normal;
          font-style:   normal;
          font-stretch: normal;
        }
      }
    }
  }
  svg{
    width: 100%;
  }
  svg:not(:root) {
    overflow: visible;
  }
  .grid-item{
    position: absolute;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
    overflow: hidden;
    .wrapper{
      width: 100%;
      height: 100%;
      position: relative;
    }
    .title_text{
      transform: translate(0,0px);
    }
    .title-scenario{
      color: white !important;
      z-index: 12;
      font-family:  'Union Regular', Helvetica, Arial, sans-serif;
      font-weight:  normal;
      font-style:   normal;
      font-stretch: normal;
      position: absolute;
      bottom: 15px;
      left: 15px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, .8);
      font-size: 14px;
      opacity: 1;
      -webkit-transition: all .6s cubic-bezier(0, 0, 0.2, 1);
      -moz-transition: all .6s cubic-bezier(0, 0, 0.2, 1);
      -ms-transition: all .6s cubic-bezier(0, 0, 0.2, 1);
      -o-transition:all .6s cubic-bezier(0, 0, 0.2, 1);
      transition: all .6s cubic-bezier(0, 0, 0.2, 1);
      &.hidden{
        opacity: 0;
      }
    }
    img{
      -webkit-transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      -moz-transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      -ms-transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      -o-transition:all 1s cubic-bezier(0, 0, 0.2, 1);
      transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      width: 100%;
      transform-origin: center;
      transform: scale(1);
    }
  }
}

 .no-touchevents{
   .info_scenario_controls{
     .buttons{
       &:hover{
         padding: .8rem 2.6rem;
       }
     }
   }
   .grid-item{
     &:hover{
       img{
         transform: scale(1.05);
       }
     }
   }
 }
</style>
